import { useCallback } from 'react'

import { useMarkPurchasesStepDone } from '@features/quickStart/hooks'

import { useSegment } from '../../../../src/hooks'
import { ExpensesReceiptUploadSources, ExpensesTrackingEvents } from '../enums/tracking'

interface UseReceiptUploadTrackingProps {
  source: (typeof ExpensesReceiptUploadSources)[keyof typeof ExpensesReceiptUploadSources]
}

export const useReceiptUploadTracking = ({ source }: UseReceiptUploadTrackingProps) => {
  const { track } = useSegment()
  const markPurchasesStepDone = useMarkPurchasesStepDone()

  return useCallback(
    (properties: Record<string, unknown> = {}) => {
      track(ExpensesTrackingEvents.ReceiptUploaded, {
        source,
        ...properties,
      })
      markPurchasesStepDone()
    },
    [track, source, markPurchasesStepDone],
  )
}
